import { module } from 'modujs';
import {gsap} from 'gsap';
import { MorphSVGPlugin } from "../vendors/gsap/MorphSVGPlugin";
import drawSvgPlugin from '../vendors/gsap/DrawSVGPlugin';
const { ScrollTrigger } = require("gsap/dist/ScrollTrigger");

export default class extends module {
  constructor(m)
  {
    super(m);


    this.items = this.el.querySelectorAll('.numbers-item')
    this.firstNumber = this.el.querySelectorAll('.numbers-first')
    this.lastNumber = this.el.querySelectorAll('.numbers-last')

    this.tweenArray = []
    console.log("✅NUMBERS✅")
  }

  init(){

    this.firstNumber.forEach((el,index)=>{

      let tweens = gsap.to(this.lastNumber[index], {
        scrollTrigger: el,
        width: el.getBoundingClientRect().width,
        ease: "power2.in",
        duration:2
      });
      this.tweenArray.push(tweens)

    })

  }


  destroy() {
    // destroy method
    this.tweenArray.forEach((el,index)=>{
      el.kill()
    })
    console.log('DESTROYED tweens')
  }

}





// WEBPACK FOOTER //
// ./scripts/modules/numbers.js